import { ReactNode } from "react";
import styled from "@emotion/styled";
import { border as borderToken, borderRadius, fontSize, layout } from "@atlas-int/tokens";
import ControlRow from "@atlas-int/ui/ControlRow";

const UIViewList = styled.ul`
  display: flex;
  flex-direction: row;
  width: 180px;
  height: ${layout.controlsHeight};
  border: 1px solid ${borderToken.control};
  border-radius: ${borderRadius.pill};
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;

  & a {
    text-decoration: none;
    color: inherit;
  }
`;

const UIViewArrow = styled.div`
  width: 28px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize["2xl"]};
  box-sizing: border-box;

  & img {
    width: 100%;
  }
`;

const SettingsRow = styled(ControlRow)`
  position: relative;
`;

interface StandardControlPanelProps {
  /** UI view selector buttons */
  viewSelectorButtons: ReactNode;
  /** Arrow icon source */
  arrowIconSrc?: string;
  /** Main dropdown content (products or markets control panel) */
  mainDropdown: ReactNode;
  /** Year inputs element */
  yearInputs: ReactNode;
  /** Product class toggle group element */
  productClassToggle: ReactNode;
  /** Settings section element (button + dropdown) */
  settingsSection: ReactNode;
}

export const StandardControlPanel = ({
  viewSelectorButtons,
  arrowIconSrc,
  mainDropdown,
  yearInputs,
  productClassToggle,
  settingsSection,
}: StandardControlPanelProps) => {
  return (
    <>
      <ControlRow
        className="viewSelector"
        label="Select what to visualize"
      >
        <UIViewList>
          {viewSelectorButtons}
        </UIViewList>
      </ControlRow>
      <ControlRow compact>
        <UIViewArrow>
          {arrowIconSrc && <img src={arrowIconSrc} alt="Arrow" />}
        </UIViewArrow>
      </ControlRow>
      {mainDropdown}
      {yearInputs}
      {productClassToggle}
      <SettingsRow>
        {settingsSection}
      </SettingsRow>
    </>
  );
};
